import ProductVariant from '../../../domains/ProductVariant'
import IShopifyCheckout from '../../../domains/shopify/ShopifyCheckout'

export const isLineItemExist = (shopifyCheckout: IShopifyCheckout, selectedVariant: ProductVariant) => {
  const lineItem = (shopifyCheckout.lineItems as any)?.find?.((item: any) => item.variantId === selectedVariant.id)
  const lineItemExist = !!lineItem
  return lineItemExist
}
